var _rect, _rect2, _line, _rect3, _rect4, _circle, _rect5, _circle2, _rect6, _circle3, _rect7, _circle4, _rect8, _circle5, _rect9, _line2, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTabletMyNewsPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 704,
  height: 360,
  viewBox: "0 0 704 360",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.500977,
  width: 703,
  height: 359,
  rx: 7.5,
  stroke: "black",
  strokeOpacity: 0.2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 20.001,
  width: 160,
  height: 23,
  fill: "#E5E5E5"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 684,
  y1: 51.501,
  x2: 20,
  y2: 51.5009,
  stroke: "black"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 59.001,
  width: 160,
  height: 29,
  fill: "#E5E5E5"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 188,
  y: 65.501,
  width: 168,
  height: 16,
  fill: "#E5E5E5"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 118.001,
  r: 10,
  fill: "#E5E5E5"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 140.001,
  width: 116.8,
  height: 130,
  fill: "#E5E5E5"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 166.801,
  cy: 118.001,
  r: 10,
  fill: "#E5E5E5"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 156.801,
  y: 140.001,
  width: 116.8,
  height: 130,
  fill: "#E5E5E5"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 303.6,
  cy: 118.001,
  r: 10,
  fill: "#E5E5E5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 293.6,
  y: 140.001,
  width: 116.8,
  height: 130,
  fill: "#E5E5E5"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 440.4,
  cy: 118.001,
  r: 10,
  fill: "#E5E5E5"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 430.4,
  y: 140.001,
  width: 116.8,
  height: 130,
  fill: "#E5E5E5"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 577.199,
  cy: 118.001,
  r: 10,
  fill: "#E5E5E5"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 567.199,
  y: 140.001,
  width: 116.8,
  height: 130,
  fill: "#E5E5E5"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 684,
  y1: 290.501,
  x2: 20,
  y2: 290.501,
  stroke: "#E5E5E5"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 310.001,
  width: 160,
  height: 30,
  fill: "#E5E5E5"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 200,
  y: 319.001,
  width: 222,
  height: 12,
  fill: "#E5E5E5"
})));
export default SvgTabletMyNewsPlaceholder;